<template>
  <div class="page-wrapper">
    <BrandHero :heading="brandConfig.thankYouHeading"/>

    <p class="body-paragraph">{{ brandConfig.thankYouBody }}</p>

    <div class="ty-card content-col">
      <div class="ty-card__row">
        <span class="ty-card__label">SUBSCRIPTION</span>
        <span class="ty-card__value ty-card__value--lime">{{ brandConfig.priceLabel }}</span>
      </div>
      <div class="ty-card__row">
        <span class="ty-card__label">RENEWS</span>
        <span class="ty-card__value ty-card__value--muted">Every week until cancelled</span>
      </div>
    </div>

    <div class="ty-spacer"></div>

    <button
        class="accept-btn content-col"
        :style="{ backgroundColor: brandConfig.buttonColor, color: brandConfig.buttonTextColor }"
        @click="onContinueClicked">
      {{ brandConfig.thankYouCtaLabel }}
    </button>

    <TermsFooter class="terms-footer-spacing"/>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import BrandHero from "@/components/BrandHero.vue";
import TermsFooter from "@/components/TermsFooter.vue";
import {triggerGTMEvent} from "@/functions/addGTM";

export default {
  name: 'ThankYouPage',
  components: {BrandHero, TermsFooter},
  computed: {
    ...mapState(['brandConfig', 'msisdn'])
  },
  methods: {
    ...mapMutations(['setMsisdn']),
    onContinueClicked() {
      triggerGTMEvent('continue_to_portal_clicked');

      const portalUrl = new URL(this.brandConfig.platformUrl);
      if (this.msisdn) portalUrl.searchParams.set('msisdn', this.msisdn);
      const entryToken = new URLSearchParams(window.location.search).get('et');
      if (entryToken) portalUrl.searchParams.set('et', entryToken);
      window.location.href = portalUrl.toString();
    }
  },
  mounted() {
    triggerGTMEvent('thank_you_page_view');

    const msisdnFromUrl = new URLSearchParams(window.location.search).get('msisdn');
    if (msisdnFromUrl) this.setMsisdn(msisdnFromUrl.replace(/\D/g, ''));
  }
}
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 38px;
}

.content-col {
  width: min(330px, 100% - 44px);
  margin-left: auto;
  margin-right: auto;
}

/* Narrower than the landing paragraph — this is what reproduces the design's
   three-line break, which falls between 272 and ~305px of available width. */
.body-paragraph {
  margin-top: 32.4px;
  margin-bottom: 0;
  max-width: 290px;
  margin-left: auto;
  margin-right: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #FFFFFF;
}

/* Bare outline — no header band and no divider, unlike the landing card. */
.ty-card {
  margin-top: 28px;
  border: 1px solid rgba(179, 245, 13, 0.54);
  border-radius: 5px;
  background-color: transparent;
  padding: 19px;
}

.ty-card__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  line-height: 15px;
  font-family: 'Poppins', sans-serif;
  font-size: 10px;
}

.ty-card__row + .ty-card__row {
  margin-top: 12.7px;
}

.ty-card__label {
  font-weight: 700;
  color: #FFFFFF;
}

.ty-card__value--lime {
  font-weight: 700;
  color: #B3F50D;
}

.ty-card__value--muted {
  font-weight: 400;
  color: #B3B3B3;
}

/* The 156px void between card and CTA is measured, and the button/footer group
   hangs off the frame bottom rather than flowing straight after the card. */
.ty-spacer {
  flex: 1 1 156px;
  min-height: 156px;
}

.accept-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 66px;
  border: none;
  border-radius: 4px;
  font-family: 'Clash Display', sans-serif;
  font-weight: 600;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.accept-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.terms-footer-spacing {
  margin-top: 24.6px;
}
</style>
